import { createFileRoute } from '@tanstack/react-router';

import { getDomainQueryOptions } from '@/_pages/domains/api-service';
import Loading from '@/_pages/domains/profile/loading';

export const Route = createFileRoute('/_private/domains/$id')({
  loader: (opts) => opts.context.queryClient.ensureQueryData(getDomainQueryOptions(opts.params.id)),
  pendingComponent: Loading,
});
